import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	modalCloseButtonLabel: {
		id: 'version-issue-associated-designs.design-carousel.design-card.issues-modal.modal-close-button-label',
		defaultMessage: 'Close',
		description: 'The label of the button to close the modal',
	},
	errorFlagTitle: {
		id: 'version-issue-associated-designs.design-carousel.design-card.issues-modal.error-flag-title',
		defaultMessage: 'Something went wrong',
		description: 'When the target design is not found, we display error flag with this title',
	},
	errorFlagDescription: {
		id: 'version-issue-associated-designs.design-carousel.design-card.issues-modal.error-flag-description',
		defaultMessage: 'Please refresh the page.',
		description: 'When the target design is not found, we display error flag with this description',
	},
	linkedTo: {
		id: 'version-issue-associated-designs.design-carousel.design-card.issues-modal.linked-to',
		defaultMessage: 'Linked to',
		description: 'The title of the section that shows issues that are linked to the current design',
	},
	manyIssues: {
		id: 'version-issue-associated-designs.design-carousel.design-card.issues-modal.many-issues',
		defaultMessage: 'Multiple issues',
		description: 'Indicating multiple issues are associated with the design',
	},
});
